import { render, staticRenderFns } from "./JuniorHighSchoolNaturalCourse.vue?vue&type=template&id=605d9597&scoped=true&"
import script from "./JuniorHighSchoolNaturalCourse.vue?vue&type=script&lang=js&"
export * from "./JuniorHighSchoolNaturalCourse.vue?vue&type=script&lang=js&"
import style0 from "./JuniorHighSchoolNaturalCourse.vue?vue&type=style&index=0&id=605d9597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d9597",
  null
  
)

export default component.exports